import React from "react";
import { Container, Box, Typography } from "@mui/material";
import styled from "styled-components";

const SuccessMessage = styled(Typography)`
  font-size: 1.5rem;
  font-weight: 600;

  @media (max-width: 767px) {
    font-size: 1.2rem;
  }
`;

const HasSubmitted = () => {
  return (
    <Container maxWidth="md">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <SuccessMessage>
         You have already answers to this survey. <br/> Thank you for your submission!
        </SuccessMessage>
      </Box>
    </Container>
  );
};

export default HasSubmitted;
